<mat-dialog-content class="mat-typography content-dialog-menu">
  <div class="container-fluid" id="menu-container">
    <div id="background-dark"></div>
    <div id="dialog-menu">
      <div class="p-1 d-flex align-items-center flex-column">

        <div class="w-100 text-end m-4" style="margin-top: 23px;">
          <img style="width: 64px; height: 45px; margin-left: 34px;" src="/assets/logos/logo-white.svg" alt="">
          <button mat-dialog-close class="btn-close-menu">FECHAR
            MENU<i class="bi bi-x" style="font-size: 28px; vertical-align: bottom;"></i></button>
        </div>
        <!-- <div style="width: 90%;max-width: 296px;">
          <input type="text" placeholder="Procurar por um produto" class="input-search" style="font-size: 12px;">
          <i class="bi bi-search"
            style="margin-left: -2em; color: var(--main-blue); font-size: 16px; border: none;"></i>
        </div> -->
        <div class="pt-0 pb-3" style="width: 90%;max-width: 296px;">
          <a href="https://portaldolojista.blukit.com.br/auth" target="_blank">
            <button class="btn-portal" style="width: 100% !important;">
              <i class="bi bi-shop" style="width: 17px;
              height: 18px;"></i>
              <span style="font-size: 12px; letter-spacing: 2.04px; line-height: 14px; margin-left: 10px;">PORTAL DO
                LOJISTA</span>
            </button>
          </a>
        </div>
      </div>

      <div class="mx-5">
        <table style="height: 100px;">
          <tbody class="">
            <tr class="menu-mobile">
              <td class="color-light-blue "> Home</td>
            </tr>
            <tr class="menu-mobile">
              <td class="color-light-blue py-3">
                <a class="color-light-blue" routerLink="/linhas" style="text-decoration: none;">
                  Produtos
                </a>
              </td>
            </tr>

            <tr class="categoria" *ngFor="let categoria of categories">
              <td class="box-categoria">
                <a (click)="closeMenu()" class="link-categoria " routerLink="/linhas/{{ categoria.slug }}">{{
                  categoria.nome
                }}
                </a>
                <i class="bi sub-menu-mobile" *ngIf="categoria.categorias.length > 0"
                  [ngClass]="{'bi-chevron-up' : categorySelected === categoria.id,'bi-chevron-down':categorySelected != categoria.id }"
                  (click)="showSubcategory(true, categoria)"></i>
              </td>
              <td *ngIf="subCategories && subCategories.length" class="dropdown"
                [ngClass]="{'active' : subCategories[0].parent_id === categorySelected && categorySelected === categoria.id}">
                <div *ngFor="let subCategorie of subCategories">
                  <div class="box-categoria">
                    <a (click)="closeMenu();" href="{{subCategorie.link}}" class="link-subcategoria ">{{
                  subCategorie.nome
                }}
                    </a>
                    <i class="bi sub-menu-mobile me-3" *ngIf="subCategorie.subcategorias"
                      [ngClass]="{'bi-chevron-up' : subCategorieSelected === subCategorie.id,'bi-chevron-down':subCategorieSelected != subCategorie.id }"
                      (click)="showSubSubcategory(true, subCategorie)"></i>
                  </div>
                  <div *ngIf="subSubCategories && subSubCategories.length" class="dropdown"
                    [ngClass]="{'active' : subSubCategories[0].parent_id === subCategorieSelected && subCategorieSelected === subCategorie.id}">
                    <div *ngFor="let subSubCategorie of subSubCategories">
                      <a *ngIf="subSubCategorie.hasProducts" (click)="closeMenu()" class="link-subsubcategoria"
                        href="{{subSubCategorie.link}}">
                        {{ subSubCategorie.nome }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr class="menu-mobile ">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3" routerLink="/onde-encontrar">
                  Onde Encontrar </a>
              </td>
            </tr>
            <tr class="menu-mobile ">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3" href="atendimento"> Atendimento </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/assistencia-tecnica"> Assistência Técnica </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/duvidas-frequentes"> Dúvidas Frequentes </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/fale-conosco"> Fale Conosco </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/financeiro"> Financeiro </a></td>
            </tr>

            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/ouvidoria"> Ouvidoria </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="https://faleseguro.com.br/welcome?uuid=3941ff81-1ade-4673-ad17-0994d7bf5a41">Canal de Ética</a></td>
            </tr>

            <tr class="menu-mobile ">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3" href="sobre"> Sobre a Blukit </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="sobre/sobre-download"> Downloads </a></td>
            </tr>
            <tr class="categoria">
              <td class="box-categoria">
                <a (click)="closeMenu()" (mouseover)="showReports()" class="link-categoria "> Relatório
                  Transparência
                </a>
                <i class="bi sub-menu-mobile"
                  [ngClass]="{'bi-chevron-up': subcategorieReports.length > 0, 'bi-chevron-down': subcategorieReports.length === 0 }"
                  (click)="showReports()"></i>
              </td>
              <td *ngIf="subcategorieReports.length" class="dropdown"
                [ngClass]="{'active': subcategorieReports.length > 0}">
                <div *ngFor="let subCategorie of subcategorieReports">
                  <div class="box-categoria">
                    <a (click)="closeMenu();" href="{{subCategorie.link}}" class="link-subcategoria " target="_blank">{{
                      subCategorie.nome }}
                    </a>
                  </div>
                </div>
              </td>
            </tr>

            <tr class="menu-mobile">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3" href="blog"> Blog</a>
              </td>
            </tr>

            <tr class="menu-mobile">
              <td class="pt-2 pb-3">
                <a class="color-light-blue pt-2 pb-3"  target="_blank" href="https://ead.blukit.com.br/">EAD</a>
              </td>
            </tr>

             <tr class="menu-mobile">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3"
                  href="https://blukit.portaldetalentos.senior.com.br/"
                  target="_blank"> Trabalhe Conosco </a></td>
              <td>
            </tr>

          </tbody>
        </table>
      </div>

      <div class="mx-5 d-flex justify-content-center flex-column">
        <div>
          <p style="color: white; font-size: 16px; line-height: 19px; letter-spacing: 0.08px;">Siga a Blukit</p>
        </div>
        <div>
          <a href="https://www.instagram.com/canalblukit/?hl=pt-br" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/instagram.svg" alt="">
          </a>
          <a href="https://pt-br.facebook.com/canalblukit/" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/facebook.svg" alt="">
          </a>
          <a href="https://www.youtube.com/channel/UCV_SG6uvpUUKaTYnOspC__w" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/youtube.svg" alt="">
          </a>
          <a href="https://www.linkedin.com/company/canalblukit/" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/linkedin.svg" alt="">
          </a>
        </div>
      </div>

    </div>
  </div>
</mat-dialog-content>
